<script setup lang="ts">
// radioボタングループ
interface Props {
  list: { id: number; name: string }[];
  modelValue: number | string;
  name?: string;
  required?: boolean;
}

const props = defineProps<Props>();

const emit = defineEmits<{
  "update:modelValue": [modelValue: number | string];
}>();

if (props.required) {
  useValidatable();
}

const localValue = computed({
  get() {
    return props.modelValue;
  },
  set(newValue) {
    emit("update:modelValue", newValue);
  },
});

const isError = ref<boolean>();

function validate() {
  // 必須でなくて値がないとき
  if (!props.required && !props.modelValue) {
    isError.value = false;
    return true;
  }

  // 必須で初期値のまま
  if (props.modelValue == 0) {
    isError.value = true;
    return false;
  }

  // テストに合格
  isError.value = false;
  return true;
}

watchDebounced(
  () => localValue.value,
  () => {
    // 値がないときは入力時のvalidateを行わない。submit時のvalidateは実行される
    if (localValue.value) {
      validate();
    }
  },
  { debounce: 500 },
);

defineExpose({ validate });
</script>

<template>
  <div ref="el">
    <label
      v-for="item in list"
      :key="item.id"
      class="flex p-2 border rounded cursor-pointer"
      :class="isError ? 'border-red-400 bg-red-100' : 'bg-white'"
    >
      <input
        :key="item.id"
        v-model="localValue"
        class="mr-2"
        type="radio"
        :name="name"
        :value="item.id"
      />
      <span class="line-clamp-1">{{ item.name }}</span>
    </label>
  </div>
</template>
